import React from "react";
import ReactEChartsCore from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";

const MonthBarGraph = ({ data }) => {
  const categories = [
    'Total Order Value',
    'Male Total Value',
    'Male Repeat Value',
    'Male New Value',
    'Female Total Value',
    'Female Repeat Value',
    'Female New Value',
  ];

  const currentValues = [
    data?.currentData?.totalOrderValue || 0,
    data?.currentData?.male?.totalValue || 0,
    data?.currentData?.male?.repeatValue || 0,
    data?.currentData?.male?.newValue || 0,
    data?.currentData?.female?.totalValue || 0,
    data?.currentData?.female?.repeatValue || 0,
    data?.currentData?.female?.newValue || 0,
  ];

  const previousValues = [
    data?.previousData?.totalOrderValue || 0,
    data?.previousData?.male?.totalValue || 0,
    data?.previousData?.male?.repeatValue || 0,
    data?.previousData?.male?.newValue || 0,
    data?.previousData?.female?.totalValue || 0,
    data?.previousData?.female?.repeatValue || 0,
    data?.previousData?.female?.newValue || 0,
  ];

  const options = {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
    },
    legend: {
      data: ['Current Data', 'Previous Data'],
      top: '10%',
    },
    grid: {
      top: '20%',
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: categories,
      axisLabel: {
        rotate: 45,
        interval: 0,
      },
    },
    yAxis: {
      type: 'value',
      name: 'Value',
    },
    series: [
      {
        name: 'Current Data',
        type: 'bar',
        data: currentValues,
        itemStyle: {
          color: '#1E90FF',
        },
        barWidth: '30%',
      },
      {
        name: 'Previous Data',
        type: 'bar',
        data: previousValues,
        itemStyle: {
          color: '#32CD32', // Updated to Lime Green
        },
        barWidth: '30%',
      },
    ],
  };

  return <ReactEChartsCore echarts={echarts} option={options} style={{ height: '500px', width: '100%' }} />;
};

export default MonthBarGraph;

